import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../store/index.js'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)

const routes = [{
		path: '/1',
		name: 'download',
		meta: {
			title: '下載測試',
		},
		component: () => import('../views/downloadTest/downloadTest.vue')
	},
	{
		path: '/',
		name: 'login',
		meta: {
			title: '華亞金融集團管理系統',
		},
		component: () => import('../views/login/login.vue')
	},
	{
		path: '/downitem/png', //導出
		name: 'downitempng',
		title: '開戶管理系統',
		meta: {
			title: '開戶管理系統',
			keyIndex: '55',
			openKeys: '2',
		},
		component: () => import('@/views/subscriptionnew/components/downItem.vue'),
	},
	{
		path: '/downitem/dalinji', //導出
		name: 'downitemdalinji',
		title: '開戶管理系統',
		meta: {
			title: '開戶管理系統',
			keyIndex: '55',
			openKeys: '4',
		},
		component: () => import('@/views/simulationtrading/componhand/dalinji.vue'),
	},
	{
		path: '/downitem/test', //導出
		name: 'test',
		title: '開戶管理系統',
		meta: {
			title: '開戶管理系統',
			keyIndex: '55',
			openKeys: '4',
		},
		component: () => import('@/views/test/test.vue'),
	},
	{
		path: '/main',
		name: 'main',
		component: () => import('../views/main/main.vue'),
		children: [{
				path: '/main/homePage',
				name: 'homePage',
				
				component: () => import('../views/homePage/homePage.vue')
			},
			{
				path:'/main/homePage1',
				name:'homePage1',
				title: '開戶管理系統',
				meta: {
					title: '開戶管理系統',
					keyIndex: '1',
					openKeys: '1'
				},
				component: () => import('../views/homePage/homePage1.vue')
			},
			{
				path:'/main/usamarket',
				name:'usamarket',
				component: () => import('../views/usamarket/index.vue')
			},
			{
				path:'/main/formsigning',
				name:'formsigning',
				component: () => import('../views/formsigning/index.vue')
			},
			{
				path: '/main/subscription',
				name: 'subscription',
				title: '開戶管理系統',
				meta: {
					title: '開戶管理系統',
					keyIndex: '21',
					openKeys: '2',
				},
				component: () => import('../views/subscription/subscription.vue')
			},
			{
				path: '/main/establishPage',
				name: 'establishPage',
				title: '開戶管理系統',
				meta: {
					title: '開戶管理系統',
					keyIndex: '21',
					openKeys: '2',
				},
				component: () => import('../views/establishPage/establishPage.vue')
			},
			{
				path: '/main/subscriptionnew', //新股认购
				name: 'subscriptionnew',
				title: '開戶管理系統',
				meta: {
					title: '開戶管理系統',
					keyIndex: '22',
					openKeys: '2',
				},
				component: () => import('../views/subscriptionnew/subscriptionnew.vue'),

			},
			{
				path: '/main/custinforma', //客戶資訊 custinforma
				name: 'custinforma',
				title: '開戶管理系統',
				meta: {
					title: '開戶管理系統',
					keyIndex: '23',
					openKeys: '3',
				},
				component: () => import('@/views/custinforma/custinforma.vue')
			},
			{
				path: '/main/leaveapplication', //申請假期 leaveapplication
				name: 'leaveapplication',
				component: () => import('../views/leaveapplication/leaveapplication.vue')
			}, 
			{
				path: '/main/simulationtrading', //模拟交易 simulationtrading
				name: 'simulationtrading',
				component: () => import('@/views/simulationtrading/simulationtrading.vue')
			},
			{
				path:'/main/monijiaoyi',
				name:'monijiaoyi',
				component:()=>import('@/views/simulationtrading/monijiaoyi.vue')
			},
			{
				path: '/main/employeeinformation', //员工信息 employeeinformation
				name: 'employeeinformation',
				component: () => import('@/views/employeeinformation/employeeinformation.vue')
			},
			{
				path: '/main/onlineaccount', //员工信息 onlineaccount
				name: 'onlineaccount',
				component: () => import('@/views/onlineaccount/onlineaccount.vue'),
				meta: {
					title: '開戶管理系統',
					keyIndex: '23',
					openKeys: '3',
				},
			},{
				path: '/main/domainname', // domainname
				name: 'domainname',
				component: () => import('@/views/domainname/domainname.vue')
			},{
				path: '/main/supplylist', // supplylist   供應列表
				name: 'supplylist',
				component: () => import('@/views/supplylist/supplylist.vue')
			},
			{
				path: '/main/mobileaccount', // mobileaccount  移动账户
				name: 'mobileaccount',
				component: () => import('@/views/mobileaccount/mobileaccount.vue')
			},
			{
				path: '/main/tuijiankehu',  // tuijiankehu  推荐客户
				name: 'tuijiankehu',
				component: () => import('@/views/tuijiankehu/tuijiankehu.vue')
			},{
				path: '/main/quanxian',  // 權限
				name: 'quanxian',
				component: () => import('@/views/quanxian/quanxian.vue')
			},
			{
				path:'/main/bankinformation',
				name:'bankinformation',
				component:()=> import('@/views/bankinformation/bankinformation')
			},
			{
				path:'/main/contractdetails',
				name:'contractdetails',
				component:()=> import('@/views/contractdetails/contractdetails')
			},
			{
				path:'/main/stockClick',
				name:'stockClick',
				component:()=> import('@/views/stockClick/stockClick')
			},
			{
				path:'/main/customerservice',
				name:'customerservice',
				component:()=> import('@/views/customerservice/customerservice')
			},
			{
				path:'/main/trpllore',
				name:'trpllore',
				component:()=> import('@/views/trpllore/trpllore')
			},
			{ 
				path:'/main/operation',//操作记录
				name:'operation',
				component:()=> import('@/views/operation/operation')
			},
			{ 
				path:'/main/usermessage',//用户信息
				name:'usermessage',
				component:()=> import('@/views/main/usermessage/usermessage.vue')
			},
			{ 
				path:'/main/stockdividends',//股票派息
				name:'stockdividends',
				component:()=> import('@/views/stockdividends/stockdividends.vue')
			},
			{ 
				path:'/main/csemail',//邮箱管理cs
				name:'csemail',
				component:()=> import('@/views/csemail/csemail.vue')
			},
			{ 
				path:'/main/sdemail',//邮箱管理sd
				name:'sdemail',
				component:()=> import('@/views/sdemail/sdemail.vue')
			},
			{ 
				path:'/main/transactionLog',//開戶日誌
				name:'transactionLog',
				component:()=> import('@/views/transactionLog/transactionLog.vue')
			},
			{ 
				path:'/main/transactionLog2',//交易日誌
				name:'transactionLog2',
				component:()=> import('@/views/transactionLog2/transactionLog2.vue')
			},
			{ 
				path:'/main/fundSubscription',//基金产品
				name:'fundSubscription',
				component:()=> import('@/views/fundSubscription/fundSubscription.vue')
			},
			{ 
				path:'/main/fundSubscriptionBuy',//基金认购
				name:'fundSubscriptionBuy',
				component:()=> import('@/views/fundSubscriptionBuy/fundSubscriptionBuy.vue')
			},
			{ 
				path:'/main/bondSubscription',//债券产品
				name:'bondSubscription',
				component:()=> import('@/views/bondSubscription/bondSubscription.vue')
			},
			{ 
				path:'/main/bondSubscriptionBuy',//债券认购
				name:'bondSubscriptionBuy',
				component:()=> import('@/views/bondSubscriptionBuy/bondSubscriptionBuy.vue')
			},
			{ 
				path:'/main/carteBlanche',//债券认购
				name:'carteBlanche',
				component:()=> import('@/views/carteBlanche/carteBlanche.vue')
			},
		],
	},
]

const router = new VueRouter({
	// mode: 'history',  
	// base:'/main',
	routes
})

router.beforeEach((to, from, next) => {
	// Store.commit('handtitle','')
	// console.log(to,from,next)
	if(from.path =="/main/customerservice"){
		// disconnect() {
		// 	//这里是监听connect事件
		// 	console.log('-----------------------斷開')
		// }
	}
	next()
})


export default router